<!--
 * @Author: zl
 * @Date: 2021-11-23 09:38:34
 * @LastEditTime: 2022-03-14 17:31:14
 * @LastEditors: zl
 * @Description: 审核产值报表
-->
<template>
	<div class="task-layout-1 filter-layout">
		<div class="filter-box no-botder">
			<h4 class="text-center mt10">
        东部新中心工程建设项目跟踪审计审核产值统计报表
			</h4>
			<el-form ref="detailsForm"
					 size="small"
					 label-width="120px"
					 class="detailForm"
					 :model="searchObj">
				<el-row>
					<el-col :span="24">
						<el-form-item label="统计时间："
									  label-width="90px">
							<span>{{ startText }}</span>
							<span v-if="startText != '' || endText != ''"
								  class="ml5 mr5">至</span>
							<span>{{ endText }}</span>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-col :span="11">
							<el-form-item label="任务类型："
										  prop="auditType"
										  label-width="90px">
								<el-checkbox-group v-model="searchObj.auditType"
												   @change="changeEvent">
									<el-checkbox label="1006004001">跟踪</el-checkbox>
									<el-checkbox label="1006004002"
												 disabled>结算</el-checkbox>
								</el-checkbox-group>
							</el-form-item>
						</el-col>
						<el-col :span="13"
								class="right-msg">
							<el-col :span="6">
								<el-form-item label="项目数量：">
									<el-col :span="14">
										<TextTooltip refName="detailObj.proNum"
													 :content="detailObj.proNum + ' 个'">
										</TextTooltip>
									</el-col>
								</el-form-item>
							</el-col>
							<el-col :span="8">
								<el-form-item label="建设单位数量：">
									<el-col :span="14">
										<TextTooltip refName="detailObj.ownerUnitNum"
													 :content="detailObj.ownerUnitNum + ' 个'">
										</TextTooltip>
									</el-col>
								</el-form-item>
							</el-col>
							<el-col :span="10">
								<el-form-item label="统计期内累计标段初审价金额："
											  label-width="230px">
									<el-col :span="24"
											class="no-botder">
										<TextTooltip refName="detailObj.cumulativeMoney"
													 :content="detailObj.cumulativeMoney + moneyUnit">
										</TextTooltip>
									</el-col>
								</el-form-item>
							</el-col>
						</el-col>
					</el-col>
					<el-col :span="24">
						<el-col :span="11">
							<el-form-item label="片区："
										  prop="isNorth"
										  label-width="90px">
								<el-checkbox-group v-model="searchObj.isNorth"
												   @change="changeEvent">
									<el-checkbox v-for="item in projectDict.xmgsqy"
												 :key="item.id"
												 :label="item.value">
										<el-tooltip effect="dark"
													:content="item.sname"
													:disabled="item.sname.length <= 8"
													placement="top">
											<span v-if="item.sname.length > 8">
												{{ item.sname.substr(0, 8) + '...' }}
											</span>
											<span v-else>{{ item.sname }}</span>
										</el-tooltip>
									</el-checkbox>
								</el-checkbox-group>
							</el-form-item>
						</el-col>
						<el-col :span="13"
								class="right-msg">
							<el-col :span="6">
								<el-form-item label="标段数量：">
									<el-col :span="14">
										<TextTooltip refName="detailObj.packNum"
													 :content="detailObj.packNum + ' 个'">
										</TextTooltip>
									</el-col>
								</el-form-item>
							</el-col>
							<el-col :span="8">
								<el-form-item label="施工单位数量：">
									<el-col :span="14">
										<TextTooltip refName="detailObj.constructionUnitNum"
													 :content="detailObj.constructionUnitNum + ' 个'">
										</TextTooltip>
									</el-col>
								</el-form-item>
							</el-col>
							<el-col :span="10">
								<el-form-item label="统计期内累计审核施工产值金额："
											  label-width="230px">
									<el-col :span="24"
											class="no-botder">
										<TextTooltip refName="detailObj.cumulativeExamineMoney"
													 :content="detailObj.cumulativeExamineMoney + moneyUnit">
										</TextTooltip>
									</el-col>
								</el-form-item>
							</el-col>
						</el-col>
					</el-col>
					<el-col :span="24">
						<el-col :span="11">
							<el-form-item label="委托方："
										  prop="entrust"
										  label-width="90px">
								<el-checkbox-group v-model="searchObj.entrust"
												   @change="changeEvent">
									<el-checkbox label="0">建设单位</el-checkbox>
									<el-checkbox label="1">审计机关</el-checkbox>
								</el-checkbox-group>
							</el-form-item>
						</el-col>
						<el-col :span="13"
								class="right-msg">
							<el-col :span="6">
								<el-form-item label="审计任务数量 ：">
									<el-col :span="14">
										<TextTooltip refName="detailObj.taskNum"
													 :content="detailObj.taskNum + ' 个'">
										</TextTooltip>
									</el-col>
								</el-form-item>
							</el-col>
							<el-col :span="8">
								<el-form-item label="协审单位数量：">
									<el-col :span="14">
										<TextTooltip refName="detailObj.assistantUnitNum"
													 :content="detailObj.assistantUnitNum + ' 个'">
										</TextTooltip>
									</el-col>
								</el-form-item>
							</el-col>
							<el-col :span="10">
								<el-form-item label="统计期内累计付款金额："
											  label-width="230px">
									<el-col :span="24"
											class="no-botder">
										<TextTooltip refName="detailObj.zhifuMoney"
													 :content="detailObj.zhifuMoney + moneyUnit">
										</TextTooltip>
									</el-col>
								</el-form-item>
							</el-col>
						</el-col>
					</el-col>
					<el-col :span="24"
							class="text-right mb10 mt10">
						<span class="font14">单位：</span>
						<el-select v-model="isFullValue"
								   @change="getStatementData"
								   class="mr10 unit-style"
								   size="small">
							<el-option label="元"
									   :value="0"></el-option>
							<el-option label="万元"
									   :value="1"></el-option>
						</el-select>
						<el-button type="primary"
								   icon="el-icon-menu"
								   size="small"
								   @click="doFilter">列过滤</el-button>
						<el-button size="small"
								   @click="exportExcel">导出Excel</el-button>
					</el-col>
				</el-row>
			</el-form>
		</div>
		<div class="filter-content w-table-layout w-table-page">

			<div class="w-table-content">
				<vxe-table align="center"
						   auto-resize
						   ref="feeTable"
						   border
						   :data="tableObj.data"
						   :loading="tableObj.loading"
						   key="10001"
						   height="100%"
						   highlight-current-row
						   highlight-hover-row
						   show-overflow="tooltip"
						   show-header-overflow="tooltip">
					<vxe-table-column type="seq"
									  title="序号"
									  width="60"></vxe-table-column>
					<vxe-table-column field="proName"
									  title="项目名称"
									  min-width="200"
									  header-align="center"
									  align="left">
						<template #default="{ row }">
							<span class="vxe-cell--label blue-text"
								  @click="viewItem(row, 'project')">
								{{ row.proName }}
							</span>
						</template>
					</vxe-table-column>
					<vxe-table-column field="packName"
									  title="标段名称"
									  min-width="200"
									  header-align="center"
									  align="left">
						<template #default="{ row }">
							<span class="vxe-cell--label blue-text"
								  @click="viewItem(row, 'pack')">
								{{ row.packName }}
							</span>
						</template>
					</vxe-table-column>
					<vxe-table-column field="area"
									  title="片区"
									  width="100">
					</vxe-table-column>
					<vxe-table-column field="auditTypeName"
									  title="任务类型"
									  min-width="120"></vxe-table-column>
					<vxe-table-column field="sponsorUnitShortName"
									  title="委托方"
									  :visible="false"
									  min-width="150"
									  header-align="center"
									  align="left">
						<template #default="{ row }">
							<el-tooltip effect="dark"
										:content="row.sponsorUnitName"
										placement="top">
								<span class="vxe-cell--label">
									{{ row.sponsorUnitShortName }}
								</span>
							</el-tooltip>
						</template>
					</vxe-table-column>
					<vxe-table-column field="entrustTime"
									  title="委托日期"
									  width="120">
						<template slot="header">
							委托日期
							<el-tooltip effect="light"
										content="委托日期:审计任务提交委托报审的时间。"
										placement="top-start">
								<svg-icon icon-class="wenhao"></svg-icon>
							</el-tooltip>
						</template>
						<template #default="{ row }">
							<el-tooltip effect="dark"
										:content="row.entrustTime"
										placement="top">
								<span class="vxe-cell--label"
									  v-if="!!row.entrustTime">
									{{ row.entrustTime.substr(0, 11) }}
								</span>
							</el-tooltip>
						</template>
					</vxe-table-column>
					<vxe-table-column field="preliminaryReviewPrice"
									  title="标段初审价"
									  width="160"
									  header-align="center"
									  align="right"></vxe-table-column>
					<vxe-table-column field="contractPrice"
									  title="合同价"
									  min-width="120"
									  header-align="center"
									  align="right"></vxe-table-column>
					<vxe-table-column field="auditOutputValue"
									  title="累计审核产值"
									  width="160"
									  header-align="center"
									  align="right"></vxe-table-column>
					<vxe-table-column field="auditOutputRate"
									  title="累计审核比例"
									  width="120"
									  header-align="center"
									  align="right">
						<template #default="{ row }">
							<span class="vxe-cell--label"
								  v-if="row.auditOutputRate != ''">
								{{ row.auditOutputRate == '-' ? row.auditOutputRate : row.auditOutputRate + '%' }}
							</span>
						</template>
					</vxe-table-column>
					<vxe-table-column field="reviewProgressPayment"
									  title="累计审核进度款"
									  width="180"
									  header-align="center"
									  align="right"></vxe-table-column>
					<vxe-table-column field="progressPayment"
									  title="累计支付进度款"
									  width="180"
									  header-align="center"
									  align="right"></vxe-table-column>
					<vxe-table-column field="archiveTime"
									  title="归档日期"
									  width="120">
						<template #default="{ row }">
							<el-tooltip effect="dark"
										:content="row.archiveTime"
										placement="top">
								<span class="vxe-cell--label"
									  v-if="!!row.archiveTime">
									{{ row.archiveTime.substr(0, 11) }}
								</span>
							</el-tooltip>
						</template>
					</vxe-table-column>
					<vxe-table-column field="ownerUnitShortName"
									  title="建设单位"
									  header-align="center"
									  align="left"
									  width="150">
						<template #default="{ row }">
							<el-tooltip effect="dark"
										:content="row.ownerUnitName"
										placement="top">
								<span class="vxe-cell--label">
									{{ row.ownerUnitShortName }}
								</span>
							</el-tooltip>
						</template>
					</vxe-table-column>
					<vxe-table-column field="ownerTaskUser"
									  title="项目负责人"
									  width="150"></vxe-table-column>
					<vxe-table-column field="ownerTaskUserConstract"
									  title="项目负责人联系电话"
									  :visible="false"
									  width="150"></vxe-table-column>
					<vxe-table-column field="auditUnitShortName"
									  title="审计机关"
									  header-align="center"
									  align="left"
									  width="150">
						<template #default="{ row }">
							<el-tooltip effect="dark"
										:content="row.auditUnitName"
										placement="top">
								<span class="vxe-cell--label">
									{{ row.auditUnitShortName }}
								</span>
							</el-tooltip>
						</template>
					</vxe-table-column>
					<vxe-table-column field="auditTaskUser"
									  title="主审"
									  width="150"></vxe-table-column>
					<vxe-table-column field="auditTaskUserConstract"
									  title="主审联系电话"
									  :visible="false"
									  width="150"></vxe-table-column>
					<vxe-table-column field="assistantUnitShortName"
									  title="协审单位"
									  header-align="center"
									  align="left"
									  width="150">
						<template #default="{ row }">
							<el-tooltip effect="dark"
										:content="row.assistantUnitName"
										placement="top">
								<span class="vxe-cell--label">
									{{ row.assistantUnitShortName }}
								</span>
							</el-tooltip>
						</template>
					</vxe-table-column>
					<vxe-table-column field="assistantTaskUser"
									  title="项目经理"
									  width="150"></vxe-table-column>
					<vxe-table-column field="assistantTaskUserConstract"
									  title="项目经理联系电话"
									  :visible="false"
									  width="150"></vxe-table-column>
					<vxe-table-column field="reasonsName"
									  title="备注"
									  width="120">
						<template #default="{ row }">
							<span>{{ row.reasonsName != '' ? row.reasonsName : '-'  }}</span>
						</template>
					</vxe-table-column>
				</vxe-table>
			</div>
			<div class="w-table-pager">
				<vxe-pager :current-page="tableObj.currentPage"
						   :page-size="tableObj.pageSize"
						   :total="tableObj.total"
						   :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
						   align="center"
						   @page-change="handleCurrentChange"></vxe-pager>
			</div>
		</div>

		<!-- 列过滤弹窗 -->
		<ColumnFilter v-if="showFilter"
					  ref="filterColumn"
					  :filterColumns="filterColumns"
					  @onFilter="onFilter"></ColumnFilter>

	</div>
</template>
<script>
import * as API from 'api/FormManager/FormManager'
import ColumnFilter from '@/views/Common/ColumnFilter'
import TextTooltip from '@/views/Common/TextTooltip'
import axios from 'axios'
import { mapState } from 'vuex'
export default {
	components: {
		ColumnFilter,
		TextTooltip,
	},
	props: {
		searchObj: {
			type: Object,
			default: () => {
				return {}
			},
		},
		activeTab: {
			type: String,
			default: '',
		},
		startText: {
			type: String,
			default: '',
		},
		endText: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			tableObj: {
				pageSize: 10,
				currentPage: 1,
				total: 0,
				loading: false,
				pageList: [10, 20, 50, 100], // 显示条数数组
				data: [],
			},
			showFilter: false,
			filterColumns: [
				{
					title: '',
					checkAll: false,
					columns: [],
				},
			],
			// 展示详情对象
			detailObj: {
				proNum: '', //项目数量
				ownerUnitNum: '', //建设单位数量
				packNum: '', //标段数量
				taskNum: '', //审计任务数量
				constructionUnitNum: '', //施工单位数量
				assistantUnitNum: '', //协审单位数量
				cumulativeMoney: '', //统计期内累计标段初审价金额
				cumulativeExamineMoney: '', //统计期内累计审核施工产值金额
				zhifuMoney: '', //统计期内累计付款金额
			},
			isFullValue: 1,
		}
	},
	created() {
		this.getSelfData()
	},
	methods: {
		// 点击列过滤
		doFilter() {
			this.showFilter = true
			setTimeout(() => {
				this.$refs.filterColumn.dialogObj.visible = true
			}, 200)
		},

		// 确认列过滤
		onFilter(arr) {
			this.tableObj.loading = true
			if (this.$refs.feeTable) {
				// 确定赋值
				this.$set(this, 'filterColumns', arr)
				this.saveSelfData()
				this.$refs.feeTable.refreshColumn()
				this.tableObj.loading = false
				return
			}
			this.tableObj.loading = false
		},

		// 获取列过滤数据
		getSelfData() {
			API.getSelfData({
				busType: '1041004',
			})
				.then((res) => {
					if (res.data.length == 0) {
						setTimeout(() => {
							let tableColumn =
								this.$refs.feeTable.getTableColumn()
							this.filterColumns[0].columns =
								tableColumn.collectColumn
						}, 1500)
						return
					}
					if (this.$refs.feeTable) {
						let tableShowColumn =
							this.$refs.feeTable.getTableColumn()
						tableShowColumn.collectColumn.forEach((x) => {
							let obj = res.data.find(
								(y) => y.field == x.property
							)
							if (obj) {
								x.visible = obj.isChecked
							}
						})
						this.filterColumns[0].columns =
							tableShowColumn.collectColumn
						this.$refs.feeTable.refreshColumn()
					}
				})
				.catch(() => {
					let tableColumn = this.$refs.feeTable.getTableColumn()
					this.filterColumns[0].columns = tableColumn.collectColumn
				})
		},

		// 保存列过滤数据
		saveSelfData() {
			this.tableObj.loading = true
			let fileds = this.filterColumns[0].columns
			let dealColumn = []
			//组装后台需要的数据格式
			fileds.forEach((f, index) => {
				dealColumn.push({
					name: f.title,
					field: f.property,
					isChecked: f.visible,
					index,
				})
			})
			API.saveSelfColumns({
				createUserid: this.userInfo.id,
				busType: '1041004',
				columnVisible: dealColumn,
			})
				.then((res) => {
					this.$message.success('列过滤保存完成！')
				})
				.catch(() => {
					this.tableObj.loading = false
				})
		},

		// 获取报表列表数据
		getStatementData(first) {
			this.tableObj.loading = true
			let params = this.$utils.clone(this.searchObj, true)
			params.size = this.tableObj.pageSize
			params.current = this.tableObj.currentPage
			params.selectStatusType = '4'
			params.isNorth.length >= 1
				? (params.isNorth = params.isNorth.join(','))
				: (params.isNorth = '')
			params.entrust.length >= 1
				? (params.entrust = params.entrust.join(','))
				: (params.entrust = '')
			params.auditType.length >= 1
				? (params.auditType = params.auditType.join(','))
				: (params.auditType = '')
			delete params.auditDate
			delete params.archiveDate
			delete params.acceptDate
			delete params.selectDate
			delete params.approveDate
			delete params.applyDate
			params.isFullValue = this.isFullValue
			API.selectAuditTaskDelegationReport(params)
				.then((res) => {
					this.tableObj.data = res.data.page.records
					this.tableObj.total = parseInt(res.data.page.total)
					Object.keys(this.detailObj).map((x) => {
						this.detailObj[x] = res.data[x]
					})
					this.tableObj.loading = false
				})
				.catch(() => {
					this.tableObj.loading = false
				})
		},
		// 导出excel
		exportExcel() {
			console.log(this.filterColumns)
			//获取列过滤的数据
			var fileds = this.filterColumns[0].columns
			//符合设定 序号不参与列过滤
			var arr = []
			//组装后台需要的数据格式
			fileds.forEach((f) => {
				//处理序号是否被选中
				if (f.property == undefined && f.title == '序号' && f.visible) {
					arr.push({
						name: '序号',
						field: 'seq',
						isCheck: true,
					})
				} else {
					arr.push({
						name: f.title,
						field: f.property,
						isCheck: f.visible,
					})
				}
			})
			let params = this.$utils.clone(this.searchObj, true)
			params.size = this.tableObj.pageSize
			params.current = this.tableObj.currentPage
			params.selectStatusType = '4'
			params.isNorth.length >= 1
				? (params.isNorth = params.isNorth.join(','))
				: (params.isNorth = '')
			params.entrust.length >= 1
				? (params.entrust = params.entrust.join(','))
				: (params.entrust = '')
			params.auditType.length >= 1
				? (params.auditType = params.auditType.join(','))
				: (params.auditType = '')
			//这里是控制是否根据列过滤导出 0 不是 1 是
			params.isAllExport = '1'
			params.statisticsTimeName = this.startText + '至' + this.endText
			params.exportExcleHeader = arr
			params.isFullValue = this.isFullValue
			delete params.auditDate
			delete params.archiveDate
			delete params.acceptDate
			delete params.selectDate
			delete params.approveDate
			delete params.applyDate
			axios
				.post(
					process.env.VUE_APP_BASE_URL +
						'busTask/exportAuditTaskDelegationReport',
					params,
					{ responseType: 'arraybuffer' }
				)
				.then((res) => {
					// 获取文件名  这里是后台使用了cache-control 放文件名称  Content-Disposition  axios不接受
					const fileName = decodeURI(
						res.headers['cache-control'].split('=')[1]
					)
					const link = document.createElement('a') // 创建元素
					let blob = new Blob([res.data], {
						type: 'application/vnd.ms-excel',
					})
					link.style.display = 'none'
					link.href = URL.createObjectURL(blob) // 创建下载的链接
					//num++
					link.setAttribute('download', fileName) // 给下载后的文件命名
					document.body.appendChild(link)
					link.click() // 点击下载
					document.body.removeChild(link) //  下载完成移除元素
					window.URL.revokeObjectURL(link.href) // 释放掉blob对象
				})
		},
		// 分页处理
		handleCurrentChange({ currentPage, pageSize }) {
			this.tableObj.currentPage = currentPage
			this.tableObj.pageSize = pageSize
			this.getStatementData()
		},

		// changeEvent
		changeEvent() {
			this.tableObj.currentPage = 1
			this.getStatementData()
		},

		// 获取标段报审状态
		getSectionStatus(status) {
			let icon = ''
			// 0：未提交报审;  1：已提交报审;  2：报审内部审核通过; 3：提交报审被驳回; 4：撤回; 5：提交报审被退回; 6：已受理
			switch (status) {
				case '1001026003':
					icon = 'section-refuse'
					break
				case '1001026004':
					icon = 'section-cancel'
					break
				case '1001026007':
					icon = 'section-return'
					break
				default:
					icon = ''
			}

			return icon
		},

		// 查看
		viewItem(data, type) {
			if (type == 'project') {
				// 储存当前菜单
				let obj = {
					meta: this.$route.meta,
					path: this.$route.path,
					name: this.$route.name,
				}
				this.$setSessionItem('activeMenu', JSON.stringify(obj))
				this.$setSessionItem(
					'activeTab',
					JSON.stringify(this.activeTab)
				)
				this.$setSessionItem('last', JSON.stringify(true))

				// 跳转路由
				this.$router.push({
					path: '/projectInfoLook',
					query: {
						menu: 'project',
						type: 'view',
						projectId: data.projectId,
					},
				})
				return
			}
			this.$emit('acceptId', data)
		},
	},
	computed: {
		moneyUnit() {
			return this.isFullValue ? ' 万元' : ' 元'
		},
		...mapState('dict', {
			projectDict: (state) => state.projectDict,
		}),
		...mapState('user', {
			userInfo: (state) => state.userInfo,
		}),
	},
}
</script>
<style lang='less' scoped>
.task-layout-1 {
	height: 100%;
	padding-left: 0;
	padding-right: 0;
	.no-botder {
		border-bottom: none !important;
		border-right: none !important;
	}
	.detailForm {
		.el-form-item {
			margin-bottom: 0 !important;
		}
		.el-col-8,
		.el-col-6 {
			.el-col-14 {
				border-right: 1px solid #eee;
			}
		}
		.el-checkbox-group {
			height: 32px !important;
		}
	}
	.section-icon {
		color: #ca0a14;
		margin-right: 3px;
		font-size: 20px;
		vertical-align: sub;
		position: absolute;
	}
	.font14 {
		font-size: 14px;
	}
	.unit-style {
		width: 100px;
	}
}
</style>
